import useJwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * Раздел прав -> его стартовая страница. Порядок = приоритет: первый доступный
 * раздел становится домашней страницей пользователя. Разделы без своей страницы
 * (вкладки артиста) здесь не нужны — в них попадают из списка исполнителей.
 */
const sectionHomeRoute = {
  questions: 'questions',
  games: 'games',
  strips: 'strips-list',
  feedback: 'feedback-stats',
  finance: 'finance',
  players: 'players-rating',
  content: 'content-suggestions',
  generator: 'generator-packs',
  'db-movies': 'movies',
  'db-music': 'music-dashboard',
  'artist-list': 'artists',
  'pack-review': 'pack-validate',
  users: 'admin-users',
}

/**
 * Домашний роут пользователя, выведенный из его прав.
 * Админ идёт на дефолтную страницу; остальные — на первый доступный по ability
 * раздел (на auth-login отправлять нельзя: там redirectIfLoggedIn, будет цикл).
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (!isUserLoggedIn()) return { name: 'auth-login' }
  if (userRole === 'admin') return '/'

  const section = Object.keys(sectionHomeRoute).find(s => ability.can('view', s))

  return section ? { name: sectionHomeRoute[section] } : { name: 'misc-not-authorized' }
}
